export default "__VITE_ASSET__C0C$6oc6__"